import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

function baseSvgProps({ size, width, height, ...rest }: IconProps) {
  return {
    width: width ?? size ?? 18,
    height: height ?? size ?? 18,
    fill: "none" as const,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": rest["aria-hidden"] ?? true,
    ...rest,
  };
}

export const SettingsGearIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M6.41363 4.02718L5.0691 3.71691C4.81713 3.65876 4.55298 3.73452 4.37013 3.91737L3.91737 4.37013C3.73452 4.55298 3.65876 4.81713 3.71691 5.0691L4.02718 6.41363C4.09733 6.7176 3.97199 7.03326 3.71242 7.20631L2.39648 8.08358C2.18783 8.2227 2.0625 8.45685 2.0625 8.70765V9.29235C2.0625 9.54315 2.18783 9.7773 2.39648 9.91642L3.71242 10.7937C3.97199 10.9667 4.09733 11.2824 4.02718 11.5864L3.71691 12.9309C3.65876 13.1829 3.73452 13.4471 3.91737 13.6299L4.37013 14.0826C4.55298 14.2655 4.81713 14.3413 5.0691 14.2831L6.41363 13.9728C6.7176 13.9027 7.03326 14.028 7.20631 14.2876L8.08358 15.6035C8.2227 15.8122 8.45685 15.9375 8.70765 15.9375H9.29235C9.54315 15.9375 9.7773 15.8122 9.91642 15.6035L10.7937 14.2876C10.9667 14.028 11.2824 13.9027 11.5864 13.9728L12.9309 14.2831C13.1829 14.3413 13.4471 14.2655 13.6299 14.0826L14.0826 13.6299C14.2655 13.4471 14.3413 13.1829 14.2831 12.9309L13.9728 11.5864C13.9027 11.2824 14.028 10.9667 14.2876 10.7937L15.6035 9.91642C15.8122 9.7773 15.9375 9.54315 15.9375 9.29235V8.70765C15.9375 8.45685 15.8122 8.2227 15.6035 8.08358L14.2876 7.20631C14.028 7.03326 13.9027 6.7176 13.9728 6.41363L14.2831 5.0691C14.3413 4.81713 14.2655 4.55298 14.0826 4.37013L13.6299 3.91737C13.4471 3.73452 13.1829 3.65876 12.9309 3.71691L11.5864 4.02718C11.2824 4.09733 10.9667 3.97199 10.7937 3.71242L9.91642 2.39648C9.7773 2.18783 9.54315 2.0625 9.29235 2.0625H8.70765C8.45685 2.0625 8.2227 2.18783 8.08358 2.39648L7.20631 3.71242C7.03326 3.97199 6.7176 4.09733 6.41363 4.02718Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M11.0625 9C11.0625 10.1391 10.1391 11.0625 9 11.0625C7.8609 11.0625 6.9375 10.1391 6.9375 9C6.9375 7.8609 7.8609 6.9375 9 6.9375C10.1391 6.9375 11.0625 7.8609 11.0625 9Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);

export const PeopleIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M11.8125 4.875C11.8125 6.4283 10.5533 7.6875 9 7.6875C7.4467 7.6875 6.1875 6.4283 6.1875 4.875C6.1875 3.3217 7.4467 2.0625 9 2.0625C10.5533 2.0625 11.8125 3.3217 11.8125 4.875Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M8.99888 9.9375C6.1522 9.9375 4.07434 11.8301 3.50257 14.3743C3.40567 14.8055 3.75577 15.1875 4.19772 15.1875H13.8001C14.2421 15.1875 14.5922 14.8055 14.4953 14.3743C13.9235 11.8301 11.8456 9.9375 8.99888 9.9375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaintBucketIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path d="M6.5625 7.125V10.6875" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" />
    <path d="M8.8125 7.5V9.1875" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" />
    <path d="M2.8125 6.9375H15.1875" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" />
    <path
      d="M14.4375 15.1875V7.5C14.4375 4.49696 12.0031 2.0625 9 2.0625C5.99696 2.0625 3.5625 4.49696 3.5625 7.5V15.1875C3.5625 15.6017 3.89828 15.9375 4.3125 15.9375H13.6875C14.1017 15.9375 14.4375 15.6017 14.4375 15.1875Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConnectorsIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M2.8125 5.25C2.8125 6.5962 3.9038 7.6875 5.25 7.6875C6.5962 7.6875 7.6875 6.5962 7.6875 5.25C7.6875 3.9038 6.5962 2.8125 5.25 2.8125C3.9038 2.8125 2.8125 3.9038 2.8125 5.25Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.8125 12.75C2.8125 14.0962 3.9038 15.1875 5.25 15.1875C6.5962 15.1875 7.6875 14.0962 7.6875 12.75C7.6875 11.4038 6.5962 10.3125 5.25 10.3125C3.9038 10.3125 2.8125 11.4038 2.8125 12.75Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3125 5.25C10.3125 6.5962 11.4038 7.6875 12.75 7.6875C14.0962 7.6875 15.1875 6.5962 15.1875 5.25C15.1875 3.9038 14.0962 2.8125 12.75 2.8125C11.4038 2.8125 10.3125 3.9038 10.3125 5.25Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3125 12.75C10.3125 14.0962 11.4038 15.1875 12.75 15.1875C14.0962 15.1875 15.1875 14.0962 15.1875 12.75C15.1875 11.4038 14.0962 10.3125 12.75 10.3125C11.4038 10.3125 10.3125 11.4038 10.3125 12.75Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.125 10.875L10.875 7.125"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BellIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M3.43936 7.06148C3.74262 4.21876 6.14114 2.0625 9 2.0625C11.8589 2.0625 14.2573 4.21876 14.5606 7.06148L15.099 12.1079C15.1462 12.5511 14.7989 12.9375 14.3532 12.9375H3.64676C3.20107 12.9375 2.85372 12.5511 2.901 12.1079L3.43936 7.06148Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12.9375C12 14.5943 10.6568 15.9375 9 15.9375C7.34314 15.9375 6 14.5943 6 12.9375"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsGearAltIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M14.8118 5.40863L9.37425 2.27798C9.14257 2.1446 8.85743 2.1446 8.62575 2.27798L3.18828 5.40861C2.95579 5.54246 2.8125 5.79031 2.8125 6.05858V11.9416C2.8125 12.2099 2.9558 12.4577 3.1883 12.5915L8.62575 15.722C8.85743 15.8554 9.14258 15.8553 9.37418 15.722L14.8118 12.5913C15.0443 12.4575 15.1875 12.2096 15.1875 11.9413V6.0586C15.1875 5.79032 15.0443 5.54249 14.8118 5.40863Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="square"
    />
    <path
      d="M11.4375 9C11.4375 10.3462 10.3462 11.4375 9 11.4375C7.65383 11.4375 6.5625 10.3462 6.5625 9C6.5625 7.65383 7.65383 6.5625 9 6.5625C10.3462 6.5625 11.4375 7.65383 11.4375 9Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="square"
    />
  </svg>
);

export const GroupIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M8.0625 5.25C8.0625 6.5962 6.9712 7.6875 5.625 7.6875C4.2788 7.6875 3.1875 6.5962 3.1875 5.25C3.1875 3.9038 4.2788 2.8125 5.625 2.8125C6.9712 2.8125 8.0625 3.9038 8.0625 5.25Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8125 5.25C14.8125 6.5962 13.7212 7.6875 12.375 7.6875C11.0288 7.6875 9.9375 6.5962 9.9375 5.25C9.9375 3.9038 11.0288 2.8125 12.375 2.8125C13.7212 2.8125 14.8125 3.9038 14.8125 5.25Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.840637 14.3853C0.772395 14.8149 1.11934 15.1875 1.55432 15.1875H9.5877C10.0227 15.1875 10.3696 14.8149 10.3014 14.3853C9.2799 7.95487 1.86214 7.95487 0.840637 14.3853Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8194 9.8853C13.3407 8.83808 16.5178 10.3388 17.1599 14.3875C17.228 14.8171 16.8809 15.1875 16.4459 15.1875H12.563"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BagIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M2.0625 14.4375C2.0625 14.8517 2.39829 15.1875 2.8125 15.1875H15.1875C15.6017 15.1875 15.9375 14.8517 15.9375 14.4375V6.5625C15.9375 6.14829 15.6017 5.8125 15.1875 5.8125H2.8125C2.39829 5.8125 2.0625 6.14829 2.0625 6.5625V14.4375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 9.5625H2.25"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9.5625L9.00165 11.4375"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00293 5.8125V3.5625C6.00293 3.14829 6.33872 2.8125 6.75293 2.8125H11.2529C11.6671 2.8125 12.0029 3.14829 12.0029 3.5625V5.8125"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleBanIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M13.9055 4.09444C12.6501 2.839 10.9157 2.0625 9 2.0625C5.16853 2.0625 2.0625 5.16853 2.0625 9C2.0625 10.9157 2.839 12.6501 4.09444 13.9055M13.9055 4.09444C15.161 5.34989 15.9375 7.08426 15.9375 9C15.9375 12.8315 12.8315 15.9375 9 15.9375C7.08426 15.9375 5.34989 15.161 4.09444 13.9055M13.9055 4.09444L4.09444 13.9055"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
  </svg>
);

export const PushIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M3.39584 12.9375L1.3125 15.0803M5.0625 14.6518L3.8125 15.9375"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9375 6.375C12.9375 7.09987 12.3499 7.6875 11.625 7.6875C10.9001 7.6875 10.3125 7.09987 10.3125 6.375C10.3125 5.65013 10.9001 5.0625 11.625 5.0625C12.3499 5.0625 12.9375 5.65013 12.9375 6.375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.54802 11.452C5.25505 10.1591 2.4375 9.20985 2.4375 9.20985L4.45511 6.85599C4.5976 6.68976 4.80561 6.59409 5.02456 6.59409H6.92171C8.41642 3.60461 10.6586 1.7362 15.8901 2.10988C16.2638 7.34146 14.3953 9.58358 11.4059 11.0783V12.9755C11.4059 13.1944 11.3102 13.4024 11.144 13.5448L8.79015 15.5625C8.79015 15.5625 7.84102 12.745 6.54802 11.452Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GiroCardsIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M12.9375 6.5625H15.1875C15.6017 6.5625 15.9375 6.89829 15.9375 7.3125V13.6875C15.9375 14.1017 15.6017 14.4375 15.1875 14.4375H5.8125C5.39828 14.4375 5.0625 14.1017 5.0625 13.6875V11.4375M5.0625 6.5625H6.1875M2.8125 11.4375H12.1875C12.6017 11.4375 12.9375 11.1017 12.9375 10.6875V4.3125C12.9375 3.89829 12.6017 3.5625 12.1875 3.5625H2.8125C2.39829 3.5625 2.0625 3.89829 2.0625 4.3125V10.6875C2.0625 11.1017 2.39828 11.4375 2.8125 11.4375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowInboxIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M9 2.25V11.25M9 11.25L5.625 7.875M9 11.25L12.375 7.875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 12.75V14.25C2.25 14.6642 2.41462 15.0614 2.70921 15.3558C3.0036 15.6502 3.40081 15.75 3.815 15.75H14.185C14.5992 15.75 14.9964 15.6502 15.2908 15.3558C15.5852 15.0614 15.75 14.6642 15.75 14.25V12.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M15.1875 4.66555C15.1875 4.34273 14.981 4.05613 14.6747 3.95404L9.23715 2.14154C9.08325 2.09023 8.91675 2.09023 8.76285 2.14154L3.32533 3.95404C3.01907 4.05613 2.8125 4.34273 2.8125 4.66555V8.93422C2.8125 12.6636 6 14.4375 9 16.0559C12 14.4375 15.1875 12.6636 15.1875 8.93422V4.66555Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaperPlaneIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M4.50044 9.00007H6.93794M4.50044 9.00007L2.53673 3.10894C2.43108 2.79199 2.76137 2.50553 3.06019 2.65494L15.0796 8.66467C15.356 8.80283 15.356 9.19725 15.0796 9.33547L3.06019 15.3452C2.76137 15.4946 2.43108 15.2081 2.53673 14.8912L4.50044 9.00007Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PluginIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M2.0625 6.5625C2.0625 6.14829 2.39829 5.8125 2.8125 5.8125H15.1875C15.6017 5.8125 15.9375 6.14829 15.9375 6.5625V13.6875C15.9375 14.1017 15.6017 14.4375 15.1875 14.4375H2.8125C2.39829 14.4375 2.0625 14.1017 2.0625 13.6875V6.5625Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5625 5.625V3.5625C3.5625 3.14829 3.89829 2.8125 4.3125 2.8125H6.9375C7.35171 2.8125 7.6875 3.14829 7.6875 3.5625V5.625"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3125 5.625V3.5625C10.3125 3.14829 10.6483 2.8125 11.0625 2.8125H13.6875C14.1017 2.8125 14.4375 3.14829 14.4375 3.5625V5.625"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GiftcardIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M10.5 3.5625V9M10.5 9V14.4375M10.5 9H15.9375M10.5 9H2.0625M10.5 9L12.5625 6.9375M10.5 9L8.4375 6.9375M10.5 9L12.5625 11.0625M10.5 9L8.4375 11.0625M2.8125 14.4375H15.1875C15.6017 14.4375 15.9375 14.1017 15.9375 13.6875V4.3125C15.9375 3.89829 15.6017 3.5625 15.1875 3.5625H2.8125C2.39829 3.5625 2.0625 3.89828 2.0625 4.3125V13.6875C2.0625 14.1017 2.39829 14.4375 2.8125 14.4375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DevicesIcon = (props: IconProps) => (
  <svg viewBox="0 0 14 14" {...baseSvgProps(props)}>
    <path
      d="M8.3125 5.6875C8.3125 5.36534 8.57366 5.10417 8.89583 5.10417H12.3958C12.718 5.10417 12.9792 5.36534 12.9792 5.6875V11.8125C12.9792 12.1347 12.718 12.3958 12.3958 12.3958H8.89583C8.57366 12.3958 8.3125 12.1347 8.3125 11.8125V5.6875Z"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0625 10.6458H11.375"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8125 5.10417V2.77083C11.8125 2.44867 11.5513 2.1875 11.2292 2.1875H2.77083C2.44867 2.1875 2.1875 2.44867 2.1875 2.77083V9.1875C2.1875 9.50967 1.92633 9.77083 1.60417 9.77083H1.02083V11.2292C1.02083 11.5513 1.282 11.8125 1.60417 11.8125H8.3125"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.1875 9.77083H8.3125"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PageLockIcon = (props: IconProps) => (
  <svg viewBox="0 0 14 14" {...baseSvgProps(props)}>
    <path
      d="M8.02083 10.3542C8.02083 10.032 8.28199 9.77083 8.60417 9.77083H11.2292C11.5513 9.77083 11.8125 10.032 11.8125 10.3542V11.8125C11.8125 12.1347 11.5513 12.3958 11.2292 12.3958H8.60417C8.28199 12.3958 8.02083 12.1347 8.02083 11.8125V10.3542Z"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M8.60417 9.33333C8.60417 8.60848 9.19182 8.02083 9.91667 8.02083C10.6415 8.02083 11.2292 8.60848 11.2292 9.33333C11.2292 9.57495 11.0333 9.77083 10.7917 9.77083H9.04167C8.80005 9.77083 8.60417 9.57495 8.60417 9.33333Z"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M6.27083 12.3958H3.35417C3.032 12.3958 2.77083 12.1347 2.77083 11.8125V2.1875C2.77083 1.86534 3.032 1.60417 3.35417 1.60417H10.6458C10.968 1.60417 11.2292 1.86534 11.2292 2.1875V6.27083"
      stroke="currentColor"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MeetingsIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M2.8125 5.4375C2.8125 4.74714 3.37214 4.1875 4.0625 4.1875H10.6875C11.3779 4.1875 11.9375 4.74714 11.9375 5.4375V12.5625C11.9375 13.2529 11.3779 13.8125 10.6875 13.8125H4.0625C3.37214 13.8125 2.8125 13.2529 2.8125 12.5625V5.4375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M11.9375 7.5L15.1875 5.625V12.375L11.9375 10.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);

export const TalentPoolsIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M15 4.5C15 5.74264 12.3137 6.75 9 6.75C5.68629 6.75 3 5.74264 3 4.5C3 3.25736 5.68629 2.25 9 2.25C12.3137 2.25 15 3.25736 15 4.5Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M3 4.5V13.5C3 14.7426 5.68629 15.75 9 15.75C12.3137 15.75 15 14.7426 15 13.5V4.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M3 9C3 10.2426 5.68629 11.25 9 11.25C12.3137 11.25 15 10.2426 15 9"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);

export const ScorecardsIcon = (props: IconProps) => (
  <svg viewBox="0 0 18 18" {...baseSvgProps(props)}>
    <path
      d="M6.1875 3.5625H5.0625C4.64829 3.5625 4.3125 3.89829 4.3125 4.3125V14.4375C4.3125 14.8517 4.64829 15.1875 5.0625 15.1875H12.9375C13.3517 15.1875 13.6875 14.8517 13.6875 14.4375V4.3125C13.6875 3.89829 13.3517 3.5625 12.9375 3.5625H11.8125"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.1875 2.8125H11.8125V4.6875H6.1875V2.8125Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 8.0625L7.6875 9L10.125 6.5625"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 11.25H11.25M6.75 13.5H9.75"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
  </svg>
);

export const QrCodeIcon = (props: IconProps) => (
  <svg viewBox="0 0 16 16" {...baseSvgProps(props)}>
    <path
      d="M9.16667 9.16667V10.8333H10.8333M11.8333 9.16667H13.5M13.5 11.8333H11.8333V13.5M9.16667 13.1667V13.5M3.16667 13.5H6.16667C6.53485 13.5 6.83333 13.2015 6.83333 12.8333V9.83333C6.83333 9.46513 6.53485 9.16667 6.16667 9.16667H3.16667C2.79848 9.16667 2.5 9.46513 2.5 9.83333V12.8333C2.5 13.2015 2.79848 13.5 3.16667 13.5ZM9.83333 6.83333H12.8333C13.2015 6.83333 13.5 6.53485 13.5 6.16667V3.16667C13.5 2.79848 13.2015 2.5 12.8333 2.5H9.83333C9.46513 2.5 9.16667 2.79848 9.16667 3.16667V6.16667C9.16667 6.53485 9.46513 6.83333 9.83333 6.83333ZM3.16667 6.83333H6.16667C6.53485 6.83333 6.83333 6.53485 6.83333 6.16667V3.16667C6.83333 2.79848 6.53485 2.5 6.16667 2.5H3.16667C2.79848 2.5 2.5 2.79848 2.5 3.16667V6.16667C2.5 6.53485 2.79848 6.83333 3.16667 6.83333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
